import React, { useState, useEffect } from 'react';

import classnames from "classnames";
import {
    Button,
    ButtonGroup,
    Row,
    UncontrolledPopover,
    PopoverBody,
    Col,
    Modal,
} from "reactstrap";

function Situacaoes({ value, onChange }) {

    const [situacoes] = useState([
        { id: '', text: 'Todos' },
        { id: 'ativo', text: 'Ativos' },
        { id: 'inativo', text: 'Inativos' },
        { id: 'em_analise', text: 'Em Análise' },
        { id: 'nao_aprovado', text: 'Não Aprovados' }
    ])


    return (
        <>
            <ButtonGroup className="btn-group-toggle" size='sm' data-toggle="buttons">
                {
                    situacoes.map((item, key) => (
                        <Button
                            className={classnames({ active: value == item.id })}
                            color="secondary"
                            onClick={() => onChange(item.id)}>
                            <input
                                autoComplete="off"
                                name="options"
                                type="radio"
                                value={value == item.id}
                            />
                            {item.text}
                        </Button>
                    ))
                }
            </ButtonGroup>
        </>
    )
}

export default Situacaoes;